import React, { useEffect, useState } from "react";
import { BsTranslate } from "react-icons/bs";
import utils from "../../../../utils/utils";
import Spinner from "../../../Spinner";
import { DynamicForm } from "../../index";
import FieldHeader from "../FieldHeader";
import styles from "./multilingualTextInput.module.css";

function MultilingualTextInput({ parameters, value, onChange, utilsData }) {
  const [model, setModel] = useState({});
  const [langToTranslate, setLangToTranslate] = useState(
    utilsData[0]["languages"] && utilsData[0]["languages"].length > 0
      ? utilsData[0]["languages"][0]["value"]
      : ""
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (
      parameters.default &&
      JSON.stringify(parameters.default) === JSON.stringify(value)
    ) {
      onChange(parameters.default);
    }
  }, []);

  useEffect(() => {
    setModel(() => {
      const val = {};
      (utilsData[0]["languages"] || []).forEach(
        (x) =>
          (val[x["value"]] = {
            label: x["name"],
            type: "textarea",
          })
      );
      return val;
    });
  }, [utilsData]);

  const translate = () => {
    if (langToTranslate && value[langToTranslate]) {
      setLoading(true);
      const translations = utilsData[0]["languages"]
        .map((x) => x["value"])
        .filter((x) => x !== langToTranslate)
        .map((x) => {
          return {
            in_lg: langToTranslate,
            out_lg: x,
            text: value[langToTranslate],
          };
        });
      utils.translate(translations).then((x) => {
        setLoading(false);
        x.forEach((y) => {
          value[y["lg"]] = y["text"];
        });
        onChange({ ...value });
      });
    }
  };

  const handleChange = function (data) {
    Object.keys(data).forEach((key) => {
      if (data[key] !== value[key]) {
        setLangToTranslate(key);
        return false;
      }
    });
    onChange(data);
  };

  return (
    <div>
      <div className={styles.header_container}>
        <FieldHeader
          label={parameters.label}
          description={parameters.description}
        />
        <div>
          <select
            className={styles.select_language_input}
            onChange={(e) => setLangToTranslate(e.target.value)}
            value={langToTranslate}
          >
            {(utilsData[0]["languages"] || []).map((x, i) => (
              <option value={x["value"]} key={i}>
                {x["name"]}
              </option>
            ))}
          </select>
          {/*<button onClick={loading ? () => {} : translate}>
                  {loading ? "Loading..." : "Translate"}
              </button>*/}

          <Spinner
            spinning={loading}
            style={{ marginLeft: "1rem", color: "#5050da" }}
            display="inline"
          />
          {!loading && (
            <BsTranslate
              onClick={translate}
              className={styles.translate_button}
            />
          )}
        </div>
      </div>

      <div style={{ marginLeft: "1rem" }}>
        <DynamicForm
          parametersModel={model}
          formData={value}
          onParameterChange={handleChange}
          utilsData={utilsData}
        />
      </div>
    </div>
  );
}

export default MultilingualTextInput;
